var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49143 1.83052H11.5932C12.0983 1.83052 12.5084 1.42041 12.5084 0.915258C12.5084 0.410105 12.0983 0 11.5932 0H5.49143C4.98628 0 4.57617 0.410105 4.57617 0.915258C4.57617 1.42041 4.98628 1.83052 5.49143 1.83052Z",
    fill: "#D75E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83024 4.8813V14.9491C1.83024 16.6338 3.19647 18 4.8811 18H12.2032C13.8878 18 15.254 16.6338 15.254 14.9491V4.8813H16.2578C16.7142 4.8813 17.0845 4.47119 17.0845 3.96604C17.0845 3.46089 16.7142 3.05078 16.2578 3.05078H0.826731C0.370322 3.05078 0 3.46089 0 3.96604C0 4.47119 0.370322 4.8813 0.826731 4.8813H1.83052H1.83024ZM6.10144 7.0169V14.339C6.10144 14.6758 6.37479 14.9491 6.71162 14.9491C7.04844 14.9491 7.32179 14.6758 7.32179 14.339V7.0169C7.32179 6.68008 7.04844 6.40673 6.71162 6.40673C6.37479 6.40673 6.10144 6.68008 6.10144 7.0169ZM9.76248 7.0169V14.339C9.76248 14.6758 10.0358 14.9491 10.3727 14.9491C10.7095 14.9491 10.9828 14.6758 10.9828 14.339V7.0169C10.9828 6.68008 10.7095 6.40673 10.3727 6.40673C10.0358 6.40673 9.76248 6.68008 9.76248 7.0169Z",
    fill: "#D75E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.b90b41bc00e6f83bcf67ec75e6504621.svg";
export { ForwardRef as ReactComponent };